import Vue from 'vue'
import profileStore from 'profileStore'
import ConfirmComponent from 'Confirm'

Date.prototype.format = function (fmt) { //author: meizz
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

module.exports = {
    alert(msg) {
        var body = document.body;
        var existElement = document.getElementById('alert');
        if (existElement) {
            clearTimeout(this.task);
            body.removeChild(existElement);
        }
        var alertElement = document.createElement('div')
        alertElement.id = 'alert'
        alertElement.innerHTML = '<span>' + msg + '</span>'
        body.appendChild(alertElement)
        this.task = setTimeout(function () {
            body.removeChild(alertElement);
        }, 3000)
        return false;
    },
    confirm(options) {
        if (!this.$confirm) {
            const Confirm = Vue.extend(ConfirmComponent);
            this.$confirm = new Confirm({
                el: document.createElement('div'),
                value: true,
                store: profileStore
            });
            document.body.appendChild(this.$confirm.$el)
        }
        let confirm = this.$confirm;
        confirm.value = true;
        confirm.title = options.title;
        confirm.text = options.text;
        confirm.cancelText = options.cancelText;
        confirm.sureText = options.sureText;
        confirm.$off('on-cancel');
        confirm.$off('on-sure');
        confirm.$on('on-cancel', function () {
            options.onCancel && options.onCancel();
            confirm.value = false
        });
        confirm.$on('on-sure', function () {
            options.onSure && options.onSure();
            confirm.value = false
        })
    },
    //先显示透明遮罩，防止重复提交，一般2秒内会返回，2秒后显示loading图
    // 保存当前活动的请求任务，
    loading() {
        var alertElement = document.getElementById('loading-mask')
        alertElement.style.display = 'block';
    },
    loaded() {
        document.getElementById('loading-mask').style.display = 'none'
    },
    getWeekDay: function (date) {
        var Week = ['日', '一', '二', '三', '四', '五', '六'];
        return '周' + Week[date.getDay()];
    },
    getAgeFromIdCardNo(idCardNo) {
        if(idCardNo.length !== 15 || idCardNo.length !== 18) {
            // 身份证号非法
            return 0
        }
        let strBirthday = ''
        if (idCardNo.length === 18) {
            strBirthday = idCardNo.substr(6, 4) + "/" + idCardNo.substr(10, 2) + "/" + idCardNo.substr(12, 2);
        } else {
            strBirthday = "19" + idCardNo.substr(6, 2) + "/" + idCardNo.substr(8, 2) + "/" + idCardNo.substr(10, 2);
        }
        //时间字符串里，必须是“/”
        const birthDate = new Date(strBirthday);
        const nowDateTime = new Date();
        let age = nowDateTime.getFullYear() - birthDate.getFullYear();
        //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
        if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() === birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    },
    //获取当前界面URL及指定参数内容
    getUrlParams(parameName) {
        //location.search是从当前URL的?号开始的字符串，即查询字符串
        var query = (location.search.length > 0 ? location.search.substring(1) : null);
        if (null != query) {
            var args = new Object();
            var pairs = query.split("&");
            for (var i = 0; i < pairs.length; i++) {
                var pos = pairs[i].indexOf("=");
                if (pos === -1)
                    continue;
                var argname = pairs[i].substring(0, pos);
                var value = pairs[i].substring(pos + 1);
                value = decodeURIComponent(value);
                args[argname] = value;
            }
            //根据键名获取值
            return args[parameName];
        }
        return null;
    },
    goPay: function () {
        var params = {
            channelId: '4',
            invokeType: '2'
        }
        window.http.get('/app/pay/config/{channelId}/{invokeType}', {
            params: params
        }).then(res => {
            if (res.data.resultCode === '1') {
                var appId = res.data.appId;
                var redirect_uri = 'http://pz.gwi.heibai.info/pay';
                var codeUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId + '&redirect_uri=' + redirect_uri + '&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect'
                window.payWindow.location = codeUrl;
                // window.open(codeUrl)
            }
        });
    },
    cancelPay: function () {
        window.payWindow.close();
    },
    //验证手机号码跟验证码
    verifyNo: function () {
        var _this = this;
        return {
            //点击验证码验证
            verifyCodeNo: function (param) {
                var mobileNumber = param.mobileNo
                if (param.hasOwnProperty('mobileNo')) {
                    if (!mobileNumber) {
                        return _this.alert('请输入手机号码')
                    }
                    if (!/^1[3456789]\d{9}$/.test(mobileNumber)) {
                        return _this.alert('请输入正确的手机号码')
                    }
                }
                return true;
            },
            //点击按钮（登录按钮，确认修改按）验证二维码跟手机号码
            butVerifyNo: function (data) {
                var mobileNumber = data.param.mobileNo
                if (!mobileNumber) {
                    return '请输入手机号码'
                }
                if (!/^1[3456789]\d{9}$/.test(mobileNumber)) {
                    return '输您输入的手机号码错误，请重新入'
                }
                if (!data.verifyCode) {
                    return '请输入验证码'
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js